<template>
  <div class="pullsheet-view">
    <div class="loading" v-if="loading">
<!--     <div class="loading"> -->
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="PullSheet" class="content">

      <section class="page-header">

        <div class="options">
          <div class="grid-options">
            <label>Thumbnail Size</label>
            <div class="toggle-switch" v-bind:class='{switched: fullsizeview}' @click="toggleViewSize">
              <div class="option" v-bind:class='{highlighted: !fullsizeview}'><i class="material-icons">view_module</i><span> Grid</span></div>
              <div class="option" v-bind:class='{highlighted: fullsizeview}'><i class="material-icons">view_stream</i><span> Full</span></div>
              <div class="highlight"></div>
            </div>
          </div>
        </div>

        <div class="print-header">
          <div class="left">
            Pullsheet - {{PullSheet.name}}
          </div>
          <div class="right">
            <img src="../assets/logo.svg">
            <h3>323.874.0404</h3>
            <h4><A href="mailto:scout@productionlocations.com">scout@productionlocations.com</A></h4>
          </div>
          <div class="clear"></div>
        </div>

        <h1>Pullsheet</h1>
        <h2>{{PullSheet.name}}</h2>

      </section>
      <div class="pullsheetphotos">

    <div class="pl-listing" v-bind:class='{grid: !fullsizeview, full: fullsizeview}'>
      <template v-for='PL in pullSheetPLs'>
        <PLThumb :key='PL.plno' :PL='PL' :fullsizeview='fullsizeview' :tagids='[]' :photofilter='"default"' :showpullsheet='false' :lazy='false' />{{' '}}
        </template>
      <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div>
    </div>
<!--
        <div class="photo" v-for="photo in PullSheet.items">
          <img :src="'https://img.productionlocations.com/' + photo.url">
        </div>
-->
      </div>


     </div><!-- /.content -->
  </div><!-- /.pl-detail -->
</template>

<script>
import PLThumb from './PLThumb'
export default {
  name: 'PullSheetView',
  components: {
    PLThumb
  },
  data () {
    return {
      loading: false,
      error: null,
      PullSheet: null,
      fullsizeview: false
    }
  },
  created () {
    this.fetchData()
    document.title = 'Pullsheet - Production Locations'
    document.head.querySelector('meta[name=description]').content = ''
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    pullSheetPLs () {
      var pls = {}
      this.PullSheet.items.forEach(photo => {
        if (!pls.hasOwnProperty(photo.plno)) {
          var plindex = this.$root.PLs.findIndex(function (pl) {
            return pl.plno === photo.plno
          })
          pls['PL' + photo.plno] = JSON.parse(JSON.stringify(this.$root.PLs[plindex]))
          pls['PL' + photo.plno].pickedPhotos = []
        }
        pls['PL' + photo.plno].pickedPhotos.push(photo.url)
      })
      console.log(pls)
      return pls
    }
  },
  methods: {
    fetchData () {
      this.error = this.PullSheet = null
      this.loading = true
      this.$http.get(this.$root.apiurl + 'pullsheet/load/', {params: { pullsheetid: this.$route.params.token }}).then(response => {
        this.loading = false
        if (!response.body.success) alert(response.body.message)
        this.PullSheet = response.body.pullsheet
      }, response => {
        this.error = response.statusText
      })
    },
    toggleViewSize: function () {
      this.fullsizeview = !this.fullsizeview
    }
  },
  mounted: function () {
    this.$root.logActivity('Viewing pullsheet ' + this.$route.params.token)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.loading {
  height: 100vh;
  padding-top: 49vh;
  box-sizing: border-box;
  text-align: center;
  background: #FFF;
}

.options {
  display: inline-block;
  float: right;
  vertical-align: top;
  @include bp(most) {
    width: 30%;
    border-left: 1px solid #DFDFDF;
    padding: 1em 0 1em 3em;
  }
  label {
    font-size: 12px;
    font-weight: 500;
    color: $darkgrey;
    line-height: 2;
  }
}
.grid-options {
  display: inline-block;
  vertical-align: top;
  width: 55px;
  @include bp(most) {
    width: 80%;
    max-width: 142px;
  }
  label {
    display: none;
    @include bp(most) {
      display: block;
    }
  }
  .toggle-switch {
    background: #D8D8D8;
    border-radius: 4px;
    position: relative;
    font-size: 12px;
    font-weight: 300;
    cursor: pointer;
		@include noselect();
    .option {
      display: inline-block;
      width: 47%;
      position: relative;
      z-index: 2;
      box-sizing: border-box;
      padding: .25em 0 .25em .25em;
      @include bp(most) {
        padding: .25em;
        width: 48%;
      }
      i {
        font-size: 18px;
        vertical-align: middle;
      }
      &.highlighted {
        color: #FFF;
      }
    }
    .highlight {
      width: 49%;
      background: $blue;
      position: absolute;
      border-radius: 4px;
      left: 0px;
      top: 0px;
      z-index: 1;
      height: 2em;
      transition: left .1s;
    }
    &.switched .highlight {
      left: 50%;
    }
    span {
      display: none;
      @include bp(most) {
        display: inline;
      }
    }
  }
}

.pl-listing {
 padding: 1%;
}
.pl-listing.grid {
  text-align: justify;
}
.justifier {
  width: 49%;
  display: inline-block;
  height: 1px;
  @include bp(most) {
    width: 32.7%;
  }
  @include bp(large) {
    width: 24%;
  }
}

.print-header {
  display: none;
  .left {
    width: 32%;
    display: inline-block;
    text-align: left;
  }
  .right {
    float: right;
    text-align: right;
    width: 64%;
    img {
      width: 35%;
      vertical-align: middle;
      float: left;
      margin-top: -.25em;
    }
    h3 {
      font-size: .825em;
      margin: 0px;
      margin-top: -.25em;
    }
    h4 {
      font-size: .5em;
      margin: 0px;
    }
    a {
      text-decoration: none;
      color: $notblack;
    }
  }
  .clear {
    clear: both;
    height: 1px;
  }
}
@page {
    size: Letter portrait;
    margin: 3em 3em 2em;
}
@media print {
  .page-header {
    background: #FFF;
    padding: .25em;
  }
  h1 {
    display: none;
  }
  h2 {
    display: none;
  }
  .options {
    display: none;
  }
  .print-header {
   display: block;
   width: 100%;
   .title {
    font-size: .75em;
    margin-bottom: .25em;
    font-family: Helvetica, Arial, sans-serif;
    margin-top: 0;
    clear: both;
   }
  }
  .pl-listing {
   padding: .5em 0 0;
  }

}

</style>



// WEBPACK FOOTER //
// PullSheetView.vue?3d7e739e